<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2ca"><strong>TIMELINE</strong></h2>
<p class="toc"><span class="float_toc">1733<span class="space"> </span> — <span class="space"> </span></span>Molasses Act</p>
<p class="toc"><span class="float_toc">1754<span class="space"> </span> — <span class="space"> </span></span>French and Indian War begins</p>
<p class="toc"><span class="float_toc">1764<span class="space"> </span> — <span class="space"> </span></span>Sugar Act</p>
<p class="toc"><span class="float_toc">1764<span class="space"> </span> — <span class="space"> </span></span>Currency Act</p>
<p class="toc"><span class="float_toc">1765<span class="space"> </span> — <span class="space"> </span></span>February: Stamp Act bill passed in Parliament</p>
<p class="toc"><span class="float_toc">1765<span class="space"> </span> — <span class="space"> </span></span>March: First Quartering Act issued</p>
<p class="toc"><span class="float_toc">1765<span class="space"> </span> — <span class="space"> </span></span>July: Sons of Liberty founded in MA</p>
<p class="toc"><span class="float_toc">1765<span class="space"> </span> — <span class="space"> </span></span>August: Raid on Hutchinson House, Boston</p>
<p class="toc"><span class="float_toc">1765<span class="space"> </span> — <span class="space"> </span></span>September: Sons of Liberty founded in NYC</p>
<p class="toc"><span class="float_toc">1765<span class="space"> </span> — <span class="space"> </span></span>November: Stamp Act goes into effect</p>
<p class="toc"><span class="float_toc">1766<span class="space"> </span> — <span class="space"> </span></span>March: Stamp Act repealed; Declaratory Act issued</p>
<p class="toc"><span class="float_toc">1766<span class="space"> </span> — <span class="space"> </span></span>August: Gage’s Army loots and burns Western part of Massachusetts</p>
<p class="toc"><span class="float_toc">1766<span class="space"> </span> — <span class="space"> </span></span>August: Liberty Boys rally 3,000 in New York City; Isaac Sears wounded</p>
<p class="toc"><span class="float_toc">1770<span class="space"> </span> — <span class="space"> </span></span>Boston Massacre</p>
<p class="toc"><span class="float_toc">1773<span class="space"> </span> — <span class="space"> </span></span>Tea Act, then Boston Tea Party</p>
<p class="toc"><span class="float_toc">1775<span class="space"> </span> — <span class="space"> </span></span>April: Paul Revere, William Dawes, Samuel Prescott ride (Battle of Lexington and Concord)</p>
<p class="toc"><span class="float_toc">1775<span class="space"> </span> — <span class="space"> </span></span>War of Independence begins</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// timeline.vue?3de46de8